<template>
  <div
    ref="scrollContainer"
    class="copilot-message-list copilot-message-list__scroller"
    @scroll="onScroll"
  >
    <CopilotMessageBubble
      v-for="message in messages"
      :key="message.id"
      :message="message"
    />
    <CopilotTypingIndicator v-if="isThinking" />
  </div>
</template>

<script>
import CopilotMessageBubble from '@baserow/modules/copilot/components/chat/CopilotMessageBubble'
import CopilotTypingIndicator from '@baserow/modules/copilot/components/chat/CopilotTypingIndicator'

export default {
  name: 'CopilotMessageList',
  components: {
    CopilotMessageBubble,
    CopilotTypingIndicator,
  },
  props: {
    /**
     * Ordered list of messages to render. The list is assumed to be sorted
     * chronologically from oldest (index 0) to newest (last index).
     */
    messages: {
      type: Array,
      required: true,
    },
    isThinking: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    messages: {
      handler() {
        this.scrollToBottom()
      },
      deep: true,
    },
    isThinking(isThinking) {
      if (isThinking) {
        this.scrollToBottom()
      }
    },
  },
  mounted() {
    this.scrollToBottom()
  },
  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.scrollContainer
        if (el) {
          el.scrollTop = el.scrollHeight
        }
      })
    },
    onScroll() {
      const el = this.$refs.scrollContainer
      if (el && el.scrollTop === 0) {
        this.$emit('load-older-messages')
      }
    },
  },
}
</script>

<style scoped lang="scss">
.copilot-message-list {
  height: 100%;
  min-height: 0;
  overflow-y: auto;
}

.copilot-message-list__scroller {
  height: 100%;
}
</style>

